<div class="container-fluid text-center color-primario-fondo h-100">
    <div class="row justify-content-center">
        <div class="col-md-9 col-sm-12">
            <div class="card mt-5">
                <div class="card-header">
                    <h1>Acceso denegado</h1>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <img class="mt-5" src="assets/logotipos/universidad-surcolombiana-normal-vertical-b.png"
                                alt="universidad-surcolombiana-vertical-l.png">
                        </div>
                        <div class="col-sm-12">
                            <h5 class="mb-3 mt-5">Lo sentimos, acceso denegado al recurso o página solicitada. Intente ingresar de nuevo.</h5>
                            <p>Puede que sus credenciales sean insuficientes o han expirado.</p>
                            <p>Si el problema persiste comuníquese con el equipo de desarrollo del CITCD.</p>
                        </div>
                        <div class="col-sm-12">
                            <a class="btn btn-primary color-primario-fondo text-white my-3"
                                [routerLink]="['/login']">Ir al inicio</a>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    CITCD
                </div>

            </div>

        </div>
    </div>
</div>
